import { DECOR_FONT_VAR } from "@innoclouds/ui";
import { applyFontFit, type FontFitRatios, resetFontFit } from "./fit";
import { setRootProperty, setRootVar } from "./root";
import { type LocalFontSlot, SECONDARY_SLOTS, type SecondarySlot } from "./settings";

export type FontVars = {
	activeWeight: string | null;
	families: Record<LocalFontSlot, string>;
	weights: Record<SecondarySlot, string | null>;
	ratios: FontFitRatios;
};

const SLOTS: LocalFontSlot[] = ["main", ...SECONDARY_SLOTS];

const FAMILY_VARS: Record<LocalFontSlot, string> = { main: "fontMain", light: "fontLight", bold: "fontBlack" };

const WEIGHT_VARS: Record<SecondarySlot, string> = { light: "fontWeightLight", bold: "fontWeightBlack" };

const BUNDLED_FAMILIES: Record<LocalFontSlot, string> = { main: "Bounded", light: "Bounded-light", bold: "Bounded-black" };

const familyStack = (slot: LocalFontSlot, family: string) => `"${family}", "${BUNDLED_FAMILIES[slot]}"`;

const ACTIVE_WEIGHT_VAR = "fontWeightActive";

export const showFontVars = ({ activeWeight, families, weights, ratios }: FontVars) => {
	setRootVar(ACTIVE_WEIGHT_VAR, activeWeight);
	for (const slot of SLOTS) setRootVar(FAMILY_VARS[slot], familyStack(slot, families[slot]));
	for (const slot of SECONDARY_SLOTS) setRootVar(WEIGHT_VARS[slot], weights[slot]);
	setRootVar(DECOR_FONT_VAR, familyStack("main", families.main));
	setRootProperty("font-synthesis", "weight");
	applyFontFit(ratios);
};

export const clearFontVars = () => {
	setRootVar(ACTIVE_WEIGHT_VAR, null);
	for (const slot of SLOTS) setRootVar(FAMILY_VARS[slot], null);
	for (const slot of SECONDARY_SLOTS) setRootVar(WEIGHT_VARS[slot], null);
	setRootVar(DECOR_FONT_VAR, null);
	setRootProperty("font-synthesis", null);
	resetFontFit();
};
